module.exports = __webpack_public_path__ + "static/media/Tio.14635ff4.png";